/**
 * uvScale: 天井・床・壁のテクスチャのスケール
 * cameraMoveDuration: firstPerson 時の camera の移動速度
 * cameraInitMode: カメラの初期モード（thirdPerson or firstPerson）
 * wallColor: 壁の色
 * nodeIconPosY: nodeアイコンのy座標
 * picIconPosY: picアイコンのy座標
 * rotateAngle: 左右の回転ボタンを押したときに回転する角度
 * doorVisibleDistance: ドアが消える距離
 */
export default {
  uvScale: 1,
  cameraMoveDuration: 60,
  cameraInitMode: "firstPerson",
  wallColor: 0xffffff,
  nodeIconPosY: 0.0,
  picIconPosY: 1.2,
  lightSkyColor: 0xffffff,
  lightIntensity: 0.97,
  rotateAngle: 90,
  doorVisibleDistance: 2
};
